import Vue from "vue";
//导⼊需要全局暴露的过滤器
import * as filters from "./index";
//全局注册过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})